"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderVersionPax = void 0;
const getOrderVersionPax = (item, type) => {
    if (!item)
        return 0;
    switch (type) {
        case "GOLF": {
            const config = item.config;
            return config.where_when_who?.number_of_golfers || 0;
        }
        case "HOTEL": {
            const config = item.config;
            return config?.where_when_who?.number_of_guests || 0;
        }
        case "TRANSFER": {
            const config = item.config;
            return config?.where_when_who?.number_of_passengers || 0;
        }
        case "EXCURSION": {
            const config = item.config;
            return config?.where_when_who?.number_of_people || 0;
        }
        case "CUSTOM": {
            const config = item.config;
            return config?.where_when_who?.pax || 0;
        }
        default:
            return 0;
    }
};
exports.getOrderVersionPax = getOrderVersionPax;
